import { LOAD_GOSPEL_CATEGORY } from '@/store/protocols'

export default [
    {
        name: 'gospel/categories',
        path: '/gospel/categories/:id/index.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_GOSPEL_CATEGORY.join('/')
        }
    }
]
